import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DocumentationComponent } from '@bn/app-shield';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { LinkListItem } from '@bn/web-ui/link-list/models';

@Component({
  templateUrl: './app-shield-waf.page.html',
  styleUrls: ['./app-shield-waf.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, DocumentationComponent],
})
export class AppShieldWafPage extends AbstractLazyDirective {
  public currentTab!: string;

  public titleFirst = 'Documentation';
  public linksFirst?: LinkListItem[] = [
    { text: 'Overview', url: 'https://bunny.net/docs/shield' },
    { text: 'Troubleshooting', url: 'https://bunny.net/docs/shield/troubleshooting' },
    { text: 'API Specifications', url: 'https://bunny.net/docs/api-reference/shield' },
  ];

  constructor() {
    super();
    // set local variable for parent page to be able to use onRouterOutletLoaded
    this.route.firstChild?.data.subscribe(({ activeTab }) => {
      this.currentTab = activeTab;
    });
  }
}
